import { useEffect, useState } from "react";

export const useIntersectionObserver = () => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [isThresholdCrossed, setIsThresholdCrossed] = useState(false);

  useEffect(() => {
    let observer: IntersectionObserver | null = null;

    if (ref) {
      observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];

          if (entry) {
            if (entry.isIntersecting) {
              setIsThresholdCrossed(false);
            } else {
              setIsThresholdCrossed(true);
            }
          }
        },
        { threshold: 0.5 },
      );

      observer.observe(ref);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref]);

  return [setRef, isThresholdCrossed] as const;
};
